// Paleta neutra (período eleitoral) — fonte única de verdade de cores da UI.
//
// Por exigência legal de período eleitoral, nenhum elemento da interface pode ter
// cor associada a partido: tudo deve ficar em tons de cinza, branco e preto.
// Os papéis semânticos (primary, success, danger, etc.) são mapeados para tons de
// cinza diferenciados por luminância, preservando a hierarquia visual sem usar cor.
//
// Escopo: apenas UI. O mapa de calor (HeatmapMG) também foi convertido para a
// escala de cinza. Apenas logos institucionais (src/assets/*) permanecem com cor
// proposital e NÃO devem consumir estes tokens.

const gray = {
  900: '#1a1a1a',
  800: '#2f2f2f',
  700: '#404040',
  600: '#595959',
  500: '#6c757d',
  400: '#8a8a8a',
  300: '#adb5bd',
  200: '#dee2e6',
  100: '#e9ecef',
  50: '#f8f9fa',
  white: '#ffffff',
  black: '#000000',
};

export const colors = {
  gray,

  // Papéis semânticos (todos neutros, diferenciados por luminância)
  primary: gray[800], // era azul/teal
  primaryHover: gray[900],
  success: gray[600], // era verde
  successHover: gray[700],
  danger: gray[900], // era vermelho (quase-preto mantém distinção)
  dangerHover: gray[800],
  warning: gray[400], // era amarelo (usar texto escuro por cima)
  warningHover: gray[500],
  info: gray[500], // era ciano
  infoHover: gray[600],
  secondary: gray[500],
  secondaryHover: gray[600],

  // Estrutura
  surface: gray.white,
  surfaceAlt: gray[50],
  border: gray[300],
  borderSubtle: gray[200],
  textPrimary: '#333333',
  textSecondary: gray[500],
  textMuted: gray[300],
  onColor: gray.white, // texto sobre fundos escuros
  focus: gray[700], // borda de foco (era azul/teal/roxo)
  focusRing: 'rgba(0, 0, 0, 0.25)', // sombra de foco

  // Navegação (eram azul institucional / petróleo)
  header: gray[900],
  headerAlt: gray[800],
  sidebar: gray[800],
  sidebarHover: gray.white,
  navbarText: '#333333',

  // Feedback (toasts/badges/alerts): fundo claro + texto/borda cinza
  successBg: gray[100],
  successText: gray[800],
  successBorder: gray[300],
  dangerBg: gray[200],
  dangerText: gray[900],
  dangerBorder: gray[400],
  warningBg: gray[100],
  warningText: gray[700],
  warningBorder: gray[300],
  infoBg: gray[50],
  infoText: gray[600],
  infoBorder: gray[200],

  // Login (gradiente roxo -> gradiente cinza)
  loginGradientFrom: gray[700],
  loginGradientTo: gray[500],
};

export default colors;
